import React from "react"
import { getImportTypeDefinition } from "utils/dataImportType"
import { areaTypes, roleTypes, findTypeValueByKey } from "utils/types"
import { GET_USERS, SUM_USERS, DELETE_USER } from "../gql"
import { CustomServerSideReactTableNew } from "../../../components/utility"
import { withBreadcrumb, useBread } from "../../../components/breadcrumb"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const UserListContainer = (props) => {
  const objectName = "使用者"
  useBread({ to: props.match.url, name: "使用者維護" }, true)

  const columnDefs = [
    { title: "使用者名稱", name: "name", type: "input" },
    { title: "公司名稱", name: "companyName", type: "input" },
    { title: "電郵", name: "email", type: "input" },
    { title: "職稱", name: "title", type: "input" },
    { title: "部門", name: "dept", type: "input" },
    { title: "角色", name: "role", type: "select", options: roleTypes }
  ]

  const fieldsDefinitions = () => {
    return [
      {
        id: "name",
        Header: "名稱",
        style: columStyle,
        accessor: "name",
        width: 200
      },
      {
        id: "companyName",
        Header: "公司",
        style: columStyle,
        width: 250,
        accessor: (user) => user.company.name
      },
      {
        id: "email",
        Header: "電郵",
        style: columStyle,
        accessor: "email",
        width: 250
      },
      {
        id: "title",
        Header: "職稱",
        style: columStyle,
        width: 200,
        accessor: "title"
      },
      {
        id: "dept",
        Header: "部門",
        style: columStyle,
        width: 200,
        accessor: "dept"
      },
      {
        id: "role",
        Header: "角色",
        style: columStyle,
        width: 150,
        accessor: (data) => findTypeValueByKey(roleTypes, data.role)
      },
      {
        id: "areas",
        Header: "區域",
        style: columStyle,
        width: 150,
        accessor: "areas",
        Cell: (cell) => {
          if (!cell.row.areas) {
            return null
          }

          let areaString = ""
          cell.row.areas.forEach((area) => {
            areaString += `${findTypeValueByKey(areaTypes, area)}, `
          })
          return <div>{areaString.substring(0, areaString.length - 2)}</div>
        }
      },
      {
        id: "isEnable",
        Header: "是否啟用",
        style: columStyle,
        width: 100,
        accessor: "isEnable",
        Cell: (cell) => {
          return <div>{cell.row.isEnable ? "是" : "否"}</div>
        }
      }
    ]
  }

  return (
    <CustomServerSideReactTableNew
      columnDefs={columnDefs}
      queryObjectGql={GET_USERS}
      sumTotalQueryObjectGql={SUM_USERS}
      deleteObjectGql={DELETE_USER}
      objectName={objectName}
      objectRoute={props.match.url}
      hasCreateButton={true}
      hasEditButton={true}
      fieldsDef={fieldsDefinitions()}
      hasUploadButton={true}
      uploadSettings={getImportTypeDefinition("USER")}
    />
  )
}

const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default withBreadcrumb(UserListContainer)
